import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

import { Link} from 'react-router-dom';

import Select from 'react-select';

import Topo from '../Layout/Topo';
import Overlay from '../Miscelania/Overlay';

import ScheduleRegimeEdit from './Elements/ScheduleRegimeEdit';
import getLocale from '../../i18n/getLocale';
class ScheduleRegime extends Component {

  constructor(props) {
    super(props);

    this.locale = getLocale();

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open',        
      },
      redirect_url: false,
      loaded: 0,
      title: '',
      regimes_list: [
        {value: 'escala', label: this.locale.RegimesDeEscala.RegimesDeTrabalho.opcoesRegimes.Escala},
        {value: 'administrativo', label: this.locale.RegimesDeEscala.RegimesDeTrabalho.opcoesRegimes.Administrativo},
      ],
      schedule_regimes: '',
      working_days: 0,
      days_off: 0,
      name: null,
      regime: null,
    };
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);

    this.loadData = this.loadData.bind(this);
    this.add = this.add.bind(this);
  }
  // Handlers
  handleChange (name, event) {

    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }

  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }

  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }

  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});      
    }
  }

  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }

  componentDidMount () {
    this.refs.request_api.header();
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.state.loaded === 1 && prevState.loaded === 0) {
      this.setState({loaded: 2}, this.loadData());
    }
  }

  loadData (event) {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      var url = config.get('api') + '/escala/regimes/'+self.props.match.params.type;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url', '/aeronave/modelos');
        if (responseJson.status === 'success') {
          var title = '';
          if (self.props.match.params.type === 'mestre') { title = self.locale.RegimesDeEscala.RegimesDeTrabalho.opcoesTitulo.MestreDeCarga; }
          if (self.props.match.params.type === 'cvo') { title = self.locale.RegimesDeEscala.RegimesDeTrabalho.opcoesTitulo.CVODVO; }
          if (self.props.match.params.type === 'escala') { title = self.locale.RegimesDeEscala.RegimesDeTrabalho.opcoesTitulo.EscalaDeTripulantes; }
          self.setState({
            schedule_regimes: responseJson.data,
            title: title,
            type: self.props.match.params.type,
          });
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        if (typeof event === 'undefined') {
          self.handleMessage();
        } else {
          self.handleAlert(event.message, event.status, 'open');
        }
      }); 
    });
  }
  
  // Fetch salvando a edição
  add(event) {
    event.preventDefault();
    this.handleAlert('', '', 'open');
    var datasave = {
      schedule_rubi: this.state.schedule_rubi,
      team_rubi: this.state.team_rubi,
      type: this.state.type,
      regime: this.state.regime,
      working_days: this.state.working_days,
      days_off: this.state.days_off,
      name: this.state.name,
    };
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/escala/regime', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        self.handleAlert(responseJson.message, responseJson.status, 'open');
        if (responseJson.status === 'success') {
          self.setState({schedule_regimes: responseJson.data});
        }
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  render() {
    var self = this;
    return (
<div>
  <Topo></Topo>
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  <div className="container-liquid">
    <div className="conteudo">
      <h3 className="page-title pull-left">{this.locale.RegimesDeEscala.RegimesDeTrabalho.titulo} - {this.state.title}</h3>
      <Link to="/aeronaves" className="btn btn-default pull-right"><i className="fa fa-chevron-left"></i> {this.locale.general.voltar}</Link>
      <div className="clearfix"></div>
      <hr/>
      <form onSubmit={this.add}>
        <div className="row">
          <div className="col-md-3">
            <div className="form-group">
              <label>{this.locale.RegimesDeEscala.RegimesDeTrabalho.formulario.Nome}:</label>
              <input type="text" name="name" className="form-control" placeholder={this.locale.RegimesDeEscala.RegimesDeTrabalho.formulario.placeholder.Nome} value={self.state.name} onChange={this.handleChange.bind(this, 'name')} />
            </div>
          </div>
          <div className="col-md-3">
            <div className="form-group">
              <label>{this.locale.RegimesDeEscala.RegimesDeTrabalho.formulario.RegimeDeTrabalho}:</label>
              <Select
                className="form-field-name"
                name="regime"
                value={self.state.regime}
                searchable={true}
                placeholder={this.locale.RegimesDeEscala.RegimesDeTrabalho.formulario.placeholder.SelecionarTipoDeRegime}
                onChange={this.handleSelectChange.bind(this, 'regime')}
                options={this.state.regimes_list}
              />
            </div>
          </div>
          <div className="col-md-3">
            <div className="form-group">
              <label>{this.locale.RegimesDeEscala.RegimesDeTrabalho.formulario.DiasDeMissao}:</label>
              <input type="number" name="working_days" className="form-control" placeholder={this.locale.RegimesDeEscala.RegimesDeTrabalho.formulario.placeholder.DiasDeMissao} value={self.state.working_days} onChange={this.handleChange.bind(this, 'working_days')} />
            </div>
          </div>
          <div className="col-md-3">
            <div className="form-group">
              <label>{this.locale.RegimesDeEscala.RegimesDeTrabalho.formulario.DiasDeFolga}:</label>
              <input type="number" name="days_off" className="form-control" placeholder={this.locale.RegimesDeEscala.RegimesDeTrabalho.formulario.placeholder.DiasDeFolga} value={self.state.days_off} onChange={this.handleChange.bind(this, 'days_off')} />
            </div>
          </div>
        </div>
        {(this.state.type !== 'escala') ?
          <div className="row">
            <div className="col-md-6">
              <div className="form-group">
                <label>{this.locale.RegimesDeEscala.RegimesDeTrabalho.formulario.IdEscalaRubi}:</label>
                <input type="text" name="schedule_rubi" className="form-control" placeholder={this.locale.RegimesDeEscala.RegimesDeTrabalho.formulario.placeholder.IdEscalaRubi} value={self.state.schedule_rubi} onChange={this.handleChange.bind(this, 'schedule_rubi')} />
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group">
                <label>{this.locale.RegimesDeEscala.RegimesDeTrabalho.formulario.IdTurmaRubi}:</label>
                <input type="text" name="team_rubi" className="form-control" placeholder={this.locale.RegimesDeEscala.RegimesDeTrabalho.formulario.placeholder.IdTurmaRubi} value={self.state.team_rubi} onChange={this.handleChange.bind(this, 'team_rubi')} />
              </div>
            </div>
          </div>
          : ''
        }

        <div>
          <button type="submit" className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-save"></i> {this.locale.RegimesDeEscala.RegimesDeTrabalho.formulario.botaoSalvarRegime}</button>
        </div>
      </form>
      <hr/>
      {(this.state.schedule_regimes === null || typeof this.state.schedule_regimes === 'undefined') ?  '' 
      : 
        <table className="table">
          <thead>
            <tr>
              <th>
                {this.locale.RegimesDeEscala.RegimesDeTrabalho.tabela.Nome}
              </th>
              {(this.state.type !== 'escala') ?
                <th>
                {this.locale.RegimesDeEscala.RegimesDeTrabalho.tabela.IdRubiEscala} 
                </th>
                : ''
              }
              {(this.state.type !== 'escala') ?
                <th>
                {this.locale.RegimesDeEscala.RegimesDeTrabalho.tabela.IdRubiTurma} 
                </th>
                : ''
              }
              <th>
                {this.locale.RegimesDeEscala.RegimesDeTrabalho.tabela.RegimeDeTrabalho}
              </th>
              <th>
                {this.locale.RegimesDeEscala.RegimesDeTrabalho.tabela.DiasDeMissao}
              </th>
              <th>
                {this.locale.RegimesDeEscala.RegimesDeTrabalho.tabela.DiasDeFolga}
              </th>
              <th>{this.locale.RegimesDeEscala.RegimesDeTrabalho.tabela.Acoes}</th>
            </tr>
          </thead>
          <tbody id="suppliers-certifications">
            {Object.keys(self.state.schedule_regimes).map(function(k) {
              return (
                <ScheduleRegimeEdit handleAlert={self.handleAlert} loadData={self.loadData} schedule_regime={self.state.schedule_regimes[k]} type={self.state.type} id={self.state.schedule_regimes[k].id} />
              );
            })}
          </tbody>
        </table>
      }
    </div>
  </div>
</div>
    );
  }
}

export default ScheduleRegime;



// WEBPACK FOOTER //
// ./src/Components/ScheduleRegime/ScheduleRegime.js